/**
 * Globalus krovimo indikatorius.
 *
 * Skaičiuoja aktyvias API užklausas + router navigacijas.
 * AppLayout pagal `isLoading` rodo viršutinį progreso barą.
 */

import { ref, computed } from 'vue';

const pendingCount = ref(0);
const navigating = ref(false);

export const isLoading = computed(() => pendingCount.value > 0 || navigating.value);

export function requestStarted() {
  pendingCount.value++;
}

export function requestFinished() {
  if (pendingCount.value > 0) pendingCount.value--;
}

export function navStarted() {
  navigating.value = true;
}

export function navFinished() {
  navigating.value = false;
}
